import { createStore } from "jotai";

// Global store instance — enables state access from non-React code (Actions, Flows)
export const appStore = createStore();
